import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";
import {LocalStorageService} from "../../../infrastructure/services/local-storage.service";
import {FormBuilder} from "@angular/forms";
import {ProcessResultService} from "../../../infrastructure/services/process-result.service";
import {of} from "rxjs";

@Component({
  selector: 'app-bulk-spinner',
  templateUrl: './bulk-spinner.component.html',
  styleUrls: ['./bulk-spinner.component.scss']
})
export class BulkSpinnerComponent implements OnInit {
  @Input() rawInitialMessage: string = "";
  @Input() rawMessage: string = "loading...";
  @Input() jobId: string = "";
  @Output() onComplete: EventEmitter<any> = new EventEmitter();

  message: string = "";

  value = 100
  intervalid!: any;

  constructor(
    private processResultService: ProcessResultService,
  ) {

  }

  ngOnInit() {
    this.getJob();
    this.intervalid = setInterval(() => {
      this.getJob();
    },1500)
  }

  async getJob() {
    if (this.jobId) {
      const response = await this.processResultService.getProcessJob({
        jobId: this.jobId,
      }).toPromise()

      const total = response.complete + response.failed + response.pending;
      const processed = response.complete + response.failed;
      const percent = processed * 100/ total;

      this.value = 100 - percent;
      this.message = this.rawMessage.replace("{{processed}}", processed).replace("{{total}}", total);

      if (percent >= 100 && this.intervalid) {
        clearInterval(this.intervalid);
        this.onComplete.emit(response);
      }
    } else {
      if (this.intervalid) {
        clearInterval(this.intervalid);
      }
      this.onComplete.emit(null);
    }
  }
}
